export default __webpack_public_path__ + "static/media/solution_61.e6c8f4e9.svg";